export const USDT = ['0x55d398326f99059fF775485246999027B3197955', 18, 'USDT']

export const SilverAddress = '0x0A00DaAE795dC3b3f2b8a3A8dD251D95FC5648fb' 

export const MultiCallAddress = '0x6E25E2E9d89d1Ba697B912599490268Ec0ec0724'